module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4WMqB"))).then(() => parcelRequire('3a9aZ'));